import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    CarouselControlColorsConstantType,
    CarouselControlDynamicStyleType,
    CarouselControlColors
} from "./type";
import {
    getTypeColors
} from "../../../../helpers/theme/typeColors";
import type {
    Mutable
} from "../../../../types";
import {
    getElevationStyle
} from "../../../../helpers/theme/elevation";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    getHitArea
} from "../../../../helpers/theme/control";
import {
    getOpaqueColor,
    webStyle
} from "../../../../utils";

export const CAROUSEL_CONTROL_ELEVATION = "level1";

export const getCarouselControlColors = ({
    isDisabled,
    isOverlaid,
    colors
}: CarouselControlColorsConstantType): CarouselControlColors => {
    const currentColors: CarouselControlColors = getTypeColors({
        variant: "outline",
        type: "neutral",
        isDisabled,
        colors
    });

    if(isDisabled && isOverlaid) {
        currentColors.containerColor = getOpaqueColor({
            color: colors.system.state.overlay.disabled.neutral,
            surface: colors.system.default.background
        });
    }

    return currentColors;
};

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    surface: {
        justifyContent: "center",
        borderStyle: "solid",
        alignItems: "center"
    },
    disabled: {
        ...webStyle({
            cursor: "not-allowed"
        })
    }
});

export const useStyles = ({
    isFocusVisible,
    currentColors,
    borderRadius,
    shapeConfigs,
    touchTargets,
    currentSize,
    pointerType,
    shadowAlpha,
    elevations,
    isDisabled,
    borders,
    colors
}: CarouselControlDynamicStyleType) => {
    const hitArea = getHitArea({
        visualSize: currentSize.minHeight,
        touchTargets,
        pointerType
    });

    const styles = {
        surface: {
            backgroundColor: currentColors.containerColor,
            borderColor: currentColors.borderColor,
            minHeight: currentSize.minHeight,
            minWidth: currentSize.minHeight,
            borderWidth: borders.line,
            ...getCornerStyle({
                radius: borderRadius,
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        container: {
            minHeight: hitArea.minHeight,
            minWidth: hitArea.minWidth
        } as Mutable<ViewStyle>
    };

    if(!isDisabled && elevations[CAROUSEL_CONTROL_ELEVATION].length) {
        Object.assign(styles.surface, getElevationStyle({
            level: CAROUSEL_CONTROL_ELEVATION,
            shadowColor: colors.system.shadow,
            shadowAlpha,
            elevations
        }));
    }

    Object.assign(styles.surface, getFocusRingStyle({
        colorKey: "neutral",
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
